import React from 'react'
import img2032 from '../components/images/iamazon.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2032} alt='amazon' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Amazon Global Account Management Overview
                    </h2>
                    <p>Optimize your international presence on Amazon with our comprehensive account management services tailored to maximize sales and visibility. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services We Offer:</h3>
                <li><b>•	Product Listing:</b> Enhance visibility with expertly crafted product listings. </li>
                <li><b>•	Advertising Campaign:</b>Maximize reach and ROI through targeted ad strategies. </li>
                <li><b>•	Coupons:</b> Attract customers with enticing discounts and special offers. </li>
                <li><b>•	Promotion:</b> Boost sales with effective promotional campaigns. </li>
                <li><b>•	Brand Registry:</b>Secure your brand’s identity and build customer trust. </li>
                <li><b>•	Brand Approval:</b> Navigate brand approval processes seamlessly. </li>
                <li><b>•	Category Approval:</b> Ensure accurate categorization of your products.</li>
                <li><b>•	GTIN Exemption:</b> Simplify product listings without GTIN requirements. </li>
                <li><b>•	Account Health:</b>Maintain a healthy seller account to avoid issues. </li>
                <li><b>•	Order Processing:</b> Streamline order management for faster fulfillment. </li>
                <li><b>•	Payment Reconciliation:</b> Ensure accurate and timely payment processing. </li>
                <li><b>•	Keyword Optimization:</b> Improve search rankings with strategic keywords. </li>
                <li><b>•	Safety Claim:</b> Manage product safety and compliance efficiently. </li>
                <li><b>•	FBA Shipping Creation:</b>Optimize FBA shipments for efficient logistics. </li>
                <li><b>•	Basic Training:</b>Equip your team with essential Amazon knowledge. </li>
                <li><b>•	Sales Boost:</b> Implement strategies for significant sales growth.</li>
            </ul>
        </>
    )
}

export default events